import { render, staticRenderFns } from "./ot-projects-index.vue?vue&type=template&id=170446b0&scoped=true&"
import script from "./ot-projects-index.vue?vue&type=script&lang=ts&"
export * from "./ot-projects-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-projects-index.vue?vue&type=style&index=0&id=170446b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170446b0",
  null
  
)

export default component.exports